/**
 * Live stock for the menu cards a storefront grid is about to draw.
 *
 * Every grid that maps rows through `toShopProduct` — the home page (server),
 * the filter refetch and Load more (ShopClient), a collection page — calls
 * this with the rows it fetched, for ANY brand: a drink sold by a hotel with
 * the food add-on sells out exactly like a restaurant's. One-shot reads only,
 * never a subscription (cost rule 3 — a digest row moves on every sale).
 */

import { fetchQuery } from "convex/nextjs";
import { api } from "@/convex/_generated/api";
import type { Id } from "@/convex/_generated/dataModel";
import { menuStockIdsFor, menuStockMap } from "./toShopProduct";

/**
 * The stock of the tracked menu items among `rows`, or undefined when there
 * are none or the read failed — toShopProduct then never calls an item sold
 * out on a guess (the checkout still checks the shelf).
 */
export async function loadMenuStock(brandId: string, rows: any[]): Promise<Map<string, number> | undefined> {
  const ids = menuStockIdsFor(rows);
  if (!brandId || ids.length === 0) return undefined;
  try {
    const res = await fetchQuery(api.foodBeverage.storefront.getMenuStockFor, {
      brandId: brandId as Id<"brands">,
      productIds: ids as Id<"products">[],
    });
    return menuStockMap(res);
  } catch {
    return undefined;
  }
}
